import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from './pages/LandingPage'
import LegalMentions from './pages/LegalMentions';
import CGU from './pages/CGU';
import ContactPage from './pages/ContactPage';
import QuiSommesNous from './pages/QuiSommesNous';
import DevenirPartenaire from './pages/DevenirPartenaire';
import TousNosLiens from './pages/TousNosLiens';
import ScrollToTop from './components/ScrollToTop';


const App = () => {
  return (
    <Router>
      <div className="bg-[#FFF]">
         <ScrollToTop />
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/mentions-legales' element={<LegalMentions />} />
          <Route path='/cgu' element={<CGU />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/qui-sommes-nous' element={<QuiSommesNous />} />
          <Route path='/devenir-partenaire' element={<DevenirPartenaire />} />
          <Route path='/infos' element={<TousNosLiens />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
